import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, Grid, Paper, Stepper, Step, StepLabel, TextField, Typography } from "@mui/material";

import { ValidateEmail } from "../Common/helpers";

export default function AmbassadorAppliance({ values, setValues, mode }) {

	const [disabled, setDisabled] = useState(true);

	const [formData, setFormData] = useState(values);
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};
	const handleSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(formData),
		};
		fetch("/api/7dbb451d099a43899ff85f6319cd8d89/" + values.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						setValues({
							...values,
							dl: res.dl,
						});
						//nextStep();
						window.location.href = "/newdealv/" + values.uid + "/00";
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		if (window.location.href.startsWith("http://localhost") && formData.email === undefined) {
			setFormData({
				...formData,
				email: "guillaume.besse+bk-" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				fname: "Guigui",
				lname: "Besse (Amb)",
			});
		}
	}, []);
	useEffect(() => {
		setDisabled(ValidateEmail(formData.email) && formData.fname && formData.lname && formData.fname.length > 0 && formData.lname.length > 0);
	}, [formData]);
	return (
		<Grid container>
			<Grid item xs={12}>
				<div style="padding-left: 10px; padding-right: 10px; max-width: 500px; ">
					<Box display="flex" justifyContent="space-between" flexDirection="column" alignItems="flex-start">
						<Box>
							<Typography variant="h5">L'ambassadeur en charge du dossier</Typography>
							<Typography variant="subtitle2" style="margin-bottom: 20px;">
								Tous les champs sont obligatoires
							</Typography>
						</Box>
						<Box style="width: 100%">
							<TextField
								id="email"
								name="email"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Email de l'ambassadeur en charge du dossier *"
								fullWidth
								margin="dense"
								size="small"
								value={formData.email}
								onChange={handleChange2}
							/>
						</Box>
						<Box style="width: 100%">
							<Grid container spacing={1}>
								<Grid item xs={6}>
									<TextField
										id="fname"
										name="fname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Prénom *"
										fullWidth
										margin="dense"
										size="small"
										value={formData.fname}
										onChange={handleChange2}
									/>
								</Grid>
								<Grid item xs={6}>
									<TextField
										id="lname"
										name="lname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Nom *"
										fullWidth
										margin="dense"
										size="small"
										value={formData.lname}
										onChange={handleChange2}
									/>
								</Grid>
							</Grid>
						</Box>
					</Box>

					{mode !== "P" && (
						<Box
							display="flex"
							justifyContent="flex-end"
							//flexDirection="column"
							alignItems="center"
						>
							<Box>
								<Button color="primary" variant="contained" onClick={handleSubmit} >
									{/* disabled={!disabled}> */}
									{formData.fname !== "" ? "Etape suivante" : "Je n'ai pas d'ambassadeur"}
								</Button>
							</Box>
						</Box>
					)}
				</div>
			</Grid>
		</Grid>
	);
}
